import { render, staticRenderFns } from "./filter-button.vue?vue&type=template&id=4bd821da&scoped=true&"
import script from "./filter-button.vue?vue&type=script&lang=js&"
export * from "./filter-button.vue?vue&type=script&lang=js&"
import style0 from "./filter-button.vue?vue&type=style&index=0&id=4bd821da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd821da",
  null
  
)

export default component.exports